import React from 'react';
import { Modal, Text, Button } from '@shopify/polaris';
import axios from 'axios';

function UpdateStatusModal({ open, onClose, article, shopOrigin, onStatusUpdateSuccess }) {
  const newStatus = article?.published ? 'Unpublish' : 'Publish';
  const handleStatusUpdate = async () => {
    try {
        const articleId = article?.article_id;
        if (!articleId) {
            console.error('No article ID provided');
            return;
        }

        const response = await axios.post(
            `/api/update-article-status/?shop=${shopOrigin}`,
            {
                articleId: `gid://shopify/Article/${articleId}`,
                published: !article.published,
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        // console.log("Response:", response);  // Log full response
        if (response.data.status === 'success') {
            onStatusUpdateSuccess(articleId, !article.published);
            onClose();
        } else {
            console.error('Failed to update article status:', response.data.message);
        }
      } catch (error) {
          console.error('Error updating article status:', error.response || error);
      }
  };


  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`${newStatus} Article`}
      primaryAction={{
        content: newStatus,
        onAction: handleStatusUpdate,
        destructive: article?.published, // Destructive for unpublish
      }}
      secondaryActions={[
        {
          content: 'Cancel',
          onAction: onClose,
        },
      ]}
    >
      <Modal.Section>
        <Text as="p">
          Are you sure you want to {newStatus.toLowerCase()} the article{' '}
          <strong>{article?.article_title}</strong>?{' '}
          {newStatus === 'Publish' 
            ? 'This will make the article visible to the public.' 
            : 'This will make the article a draft and hide it from public view.'}
        </Text>
      </Modal.Section>
    </Modal>
  );
}

export default UpdateStatusModal;